<template>
  <div class="flex flex-col space-y-3">
    <slot />
    <div v-if="isError" class="text-red mt-2">
      {{ errorText }}
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class FieldControl extends Vue {
  @Prop({ type: String, required: true }) errorText!: string;
  @Prop({ type: Boolean, default: false }) isError!: boolean;
}
</script>
